const PAGE_AUTH_TYPES = {
  REQUIRED: 'required',

  OPTIONAL: 'optional',

  UNNECESSARY: 'unnecessary',
} as const;

export const PAGE_LIST = {
  /** ログイン */
  LOGIN: {
    pathname: () => '/auth/login',
    authType: PAGE_AUTH_TYPES.UNNECESSARY,
    head: {
      title: '管理者ログイン',
      description: '',
    },
  },
  /** 充電ステーション */
  HOME: {
    pathname: () => '/',
    authType: PAGE_AUTH_TYPES.REQUIRED,
    head: {
      title: 'HOME',
      description: '',
    },
  },
  /** 設定 */
  SETTING: {
    pathname: () => '/auth/setting',
    authType: PAGE_AUTH_TYPES.UNNECESSARY,
    head: {
      title: 'SETTING',
      description: '',
    },
  },
} as const;
